import { GreenScreenMascot } from "@/components/GreenScreenMascot";

import { Link } from "react-router-dom";

import { motion } from "framer-motion";

import { ArrowLeft } from "lucide-react";

import { MatrixRain } from "@/components/MatrixRain";

export default function ComingSoon() {
    return (
        <div
            data-testid="coming-soon-page"
            className="relative flex min-h-screen items-center justify-center overflow-hidden bg-black grain scanlines px-6"
        >
            <MatrixRain />

            <GreenScreenMascot />

            {/* Dark radial vignette */}
            <div
                className="pointer-events-none fixed inset-0 z-[1]"
                style={{
                    background:
                        "radial-gradient(120% 90% at 50% 0%, rgba(0,0,0,0.2), rgba(0,0,0,0.85) 75%)",
                }}
                aria-hidden
            />

            <div className="relative z-20 flex flex-col items-center text-center">
                <motion.p
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.6 }}
                    className="mb-6 font-mono text-xs uppercase tracking-[0.35em] text-matrix-orange animate-glow-pulse"
                >
                    Comik Re-Leaf // the comeback is real
                </motion.p>

                <motion.h1
                    initial={{ opacity: 0, y: 24 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{
                        duration: 0.8,
                        ease: [0.16, 1, 0.3, 1],
                    }}
                    className="font-display text-4xl font-black uppercase tracking-tighter sm:text-6xl"
                    data-testid="coming-soon-heading"
                >
                    <span className="text-stroke">
                        Merch In T-Minus Like...
                    </span>{" "}
                    <span className="text-white">
                        2 Freakin' Days Bro!
                    </span>
                </motion.h1>

                <motion.p
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{
                        delay: 0.9,
                        duration: 0.7,
                    }}
                    className="mt-2 font-display text-2xl font-black uppercase tracking-tighter text-white sm:text-3xl"
                >
                    (we almost went live 2 days ago)
                </motion.p>

                <motion.p
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{
                        delay: 0.4,
                        duration: 0.7,
                    }}
                    className="mt-6 max-w-xl font-mono text-base leading-relaxed text-white/70 sm:text-lg"
                    data-testid="coming-soon-body"
                >
                    <span className="text-matrix-green">
                        &gt;
                    </span>{" "}
                    💪 95% Complete! 💪
                </motion.p>

                <motion.p
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{
                        delay: 0.6,
                        duration: 0.7,
                    }}
                    className="mt-4 max-w-lg font-mono text-xs leading-relaxed text-white/40 sm:text-sm"
                >
                    The store is alive. We're just closing
                    the gap between suppliers to get you 
                    better prices! Honestly we were gonna
                    be open for business a few days ago! 😎
                    Suppliers in contact 1/2
                </motion.p>

                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{
                        delay: 0.8,
                        duration: 0.7,
                    }}
                >
                    <Link
                        to="/"
                        data-testid="coming-soon-back"
                        className="mt-10 inline-flex items-center gap-2 rounded-full border border-matrix-green/40 px-7 py-3 font-display text-sm font-bold uppercase tracking-wider text-matrix-green no-underline transition-all duration-300 hover:bg-matrix-green/10 hover:shadow-[0_0_24px_rgba(0,255,136,0.3)]"
                    >
                        <ArrowLeft className="h-4 w-4" />
                        Back to the Grid
                    </Link>
                </motion.div>
            </div>
        </div>
    );
}